import get from "lodash/get";
import uiStrings from "./ui-strings.json";

/**
 * Retrieves a localized string from the UI strings JSON file.
 * 
 * @param id - The string key or full path to retrieve.
 *   - If `stringPath` is provided: use only the key (e.g., "value1")
 *   - If `stringPath` is omitted: use the full dot-notation path (e.g., "field.subfield.value1")
 * 
 * @param stringPath - Optional base path prefix (e.g., "field.subfield").
 *   When provided, it's combined with `id` to form the complete path.
 * 
 * @param obj - Optional key-value pairs for string interpolation.
 *   Replaces {{key}} placeholders in the string with corresponding values.
 *   Example: obj = {name: "John"} replaces {{name}} with "John"
 * 
 * @returns The localized string, with placeholders replaced if `obj` is provided.
 *   Returns empty string if the path is not found.
 * 
 * @example
 * // Using full path
 * getString("errors.validation.required") // "This field is required"
 * 
 * @example
 * // Using base path + key
 * getString("required", "errors.validation") // "This field is required"
 * 
 * @example
 * // With interpolation
 * getString("greeting", undefined, {name: "Alice"}) // "Hello, Alice!"
 */
export function getString(id: string, stringPath?: string, obj?: { [key: string]: any }): string {
    let fullPath = stringPath ? stringPath + "." + id : id;
    let outputString = get(uiStrings, fullPath, "");
    if (obj != null) {
        for (const key in obj) {
            const formatKey = "{{" + key + "}}";
            outputString = outputString.replace(formatKey, obj[key]);
        }
    }
    return outputString;
};